// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608031202/js/" + chunkId + "." + {"44":"15e09388","225":"e4900c52","481":"7529ec99","486":"264f890d","770":"7b2a324d"}[chunkId] + ".0.03842108237186648.chunk.js";
};